export default __webpack_public_path__ + "static/anilPokhriyal6-2495fd3fbb424880562ef5306fea8df5.jpg";